<template>
  <div class="c-report-progress">
    <ol class="c-report-progress__list" aria-label="Progress bar">
      <li class="c-report-progress__list-item c-report-progress__list-item--problem" v-bind:class="stepState(1)">
        <span class="c-report-progress__list-item-step">Step 1</span>
        <span class="c-report-progress__list-item-label">{{stepOneTitle}}</span>
        <span class="visually-hidden">{{ textState(1) }}</span>
        <svg class="c-report-progress__list-item-icon" aria-hidden="true" focusable="false" v-if="showTick(1)">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tick"></use>
        </svg>
      </li>
      <li class="c-report-progress__list-item c-report-progress__list-item--location" v-bind:class="stepState(2)">
        <span class="c-report-progress__list-item-step">Step 2</span>
        <span class="c-report-progress__list-item-label">{{stepTwoTitle}}</span>
        <span class="visually-hidden">{{ textState(2) }}</span>
        <svg class="c-report-progress__list-item-icon" aria-hidden="true" focusable="false" v-if="showTick(2)">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tick"></use>
        </svg>
      </li>
      <li class="c-report-progress__list-item c-report-progress__list-item--about-you" v-bind:class="stepState(3)">
        <span class="c-report-progress__list-item-step">Step 3</span>
        <span class="c-report-progress__list-item-label">{{stepThreeTitle}}</span>
        <span class="visually-hidden">{{ textState(3) }}</span>
        <svg class="c-report-progress__list-item-icon" aria-hidden="true" focusable="false" v-if="showTick(3)">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tick"></use>
        </svg>
      </li>
      <li class="c-report-progress__list-item c-report-progress__list-item--leave-it-with-us" v-bind:class="stepState(4)">
        <span class="c-report-progress__list-item-step">Step 4</span>
        <span class="c-report-progress__list-item-label">{{stepFourTitle}}</span>
        <span class="visually-hidden">{{ textState(4) }}</span>
        <svg class="c-report-progress__list-item-icon" aria-hidden="true" focusable="false" v-if="showTick(4)">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#tick"></use>
        </svg>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      required: true,
      type: Number,
    },
    stepOneTitle: {
      required: true,
      type: String
    },
    stepTwoTitle: {
      required: true,
      type: String
    },
    stepThreeTitle: {
      required: true,
      type: String
    },
    stepFourTitle: {
      required: true,
      type: String
    }
  },
  computed: {
    valueNow() {
      return (this.currentStep / 4) * 100;
    }
  },
  methods: {
    showTick(step) {
      return step < this.currentStep;
    },
    stepState(step) {
      if (step === this.currentStep) {
        return 'is-active';
      } else if (step < this.currentStep) {
        return 'is-completed';
      }
      return '';
    },
    textState(step) {
      return step < this.currentStep ? '- completed' : '- pending';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/ProgressBar.vue